var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIconJrvMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.709 2.9h5.1v1.134h-5.1V2.9zM5.709 5.166h5.1v1.133h-5.1V5.166zM5.709 7.434h5.1v1.133h-5.1V7.434zM5.709 9.7h5.1v1.133h-5.1V9.699zM5.709 11.967h5.1V13.1h-5.1v-1.133zM3.442 2.9h1.134v1.134H3.442V2.9zM3.442 5.166h1.134v1.133H3.442V5.166zM3.442 7.434h1.134v1.133H3.442V7.434zM3.442 9.7h1.134v1.133H3.442V9.699zM3.442 11.967h1.134V13.1H3.442v-1.133z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.984 0H1.734a1.2 1.2 0 0 0-.796.293.947.947 0 0 0-.33.707v14c0 .265.12.52.33.707a1.2 1.2 0 0 0 .796.293h11.25a1.2 1.2 0 0 0 .795-.293.947.947 0 0 0 .33-.707V1a.947.947 0 0 0-.33-.707A1.2 1.2 0 0 0 12.984 0zm0 15H1.734V1h11.25v14z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconJrvMobile);
export default __webpack_public_path__ + "static/media/list_icon_jrv_mobile.932b33952035292ebc086f4f44fd7b8d.svg";
export { ForwardRef as ReactComponent };